import { createContext } from 'react';

type EnvironmentScopeValue = 'all' | `${number}`;

export type EnvironmentScopeContextValue = {
  environmentScope: EnvironmentScopeValue;
  selectedEnvironmentId?: number;
  setEnvironmentScope: (scope: EnvironmentScopeValue) => void;
};

export const EnvironmentScopeContext = createContext<EnvironmentScopeContextValue | null>(null);